<script setup>
defineProps({
  title: {
    type: String,
    required: true,
    default: '',
  },
  subtitle: {
    type: String,
    required: true,
    default: '',
  },
  centered: {
    type: Boolean,
    required: false,
    default: false,
  },
  overlap: {
    type: Boolean,
    required: false,
    default: false,
  },
  heightAuto: {
    type: Boolean,
    required: false,
    default: false,
  },
})
</script>

<template>
  <div
    class="flex items-center bg-cover bg-center"
    :class="[
      { 'h-[220px] pb-8 lg:h-[264px]': overlap },
      { 'mb-6 h-52': !overlap },
      { '!h-auto': heightAuto },
    ]"
  >
    <Container class="flex items-center">
      <div v-if="!centered" class="hidden w-1/3 lg:block"></div>
      <div
        :class="[{ 'w-2/3': !centered }, { 'w-full text-center': centered }]"
      >
        <div class="mx-auto w-full py-10 text-center">
          <h1
            class="font-heading text-4xl font-medium uppercase text-secondary"
          >
            {{ title }}
          </h1>
          <p>
            {{ subtitle }}
          </p>
        </div>
      </div>
    </Container>
  </div>
</template>
